import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.promise.js";
import { passportUrl } from '../config/domain';
import { dateFormat } from '../utils/time/format';
import Url from '../utils/url';
export default {
  appName: 'quick_app',
  useKNB: false,
  sellChannel: 42,
  // 渠道号
  theme: 'maoyan',
  hostPrefix: '//show.maoyan.com/qqw',
  hostBetaPrefix: '//show.test.maoyan.com/qqw',
  ajaxUrl: 'https://wx.maoyan.com/maoyansh/myshow/ajax',
  ajaxBetaUrl: 'http://m.51ping.com/myshow/ajax',
  linkMap: {
    // 地址跳转映射
    // 首页
    '/myshow/index.html': '/',
    '/myshow/': '/',
    '/movieshow/index.html': '/',
    // 列表相关
    '/movieshowlist/graphic-detail.html': '/graphic',
    '/movieshowlist/show-ticket.html': '/list',
    '/movieshowlist/show-merchant.html': '/merchants',
    '/movieshowlist/show-detail.html': '/detail',
    '/movieshowlist/group.html': '/group',
    '/movieshowlist/search.html': '/search',
    '/movieshowlist/show-shop.html': '/shop',
    // 下单相关
    '/movieshoworder/goods.html': '/tickets',
    '/movieshoworder/pre-order.html': '/confirm',
    '/movieshoworder/area.html': '/partition',
    '/movieshoworder/add-address.html': '/add-addr',
    '/movieshoworder/choose-address.html': '/choose-addr',
    '/movieshoworder/coupon-detail.html': '/coupon-detail',
    '/movieshoworder/seats.html': '/seats',
    '/movieshoworder/coupon.html': '/coupon',
    '/movieshoworder/order-detail.html': '/order-detail',
    '/movieshoworder/order-list.html': '/order-list',
    '/movieshoworder/real-names.html': '/realname',
    '/movieshoworder/seat-area.html': '/seat-area',
    '/movieshoworder/select-seats.html': '/select-seats',
    '/movieshoworder/search-order.html': '/search-order'
  },
  getUserInfo: function getUserInfo() {
    var token = Url.getQuery('_token') || Url.getHashQuery('_token') || Url.getQuery('token') || Url.getHashQuery('token');
    if (token === 'unlogin') {
      localStorage.removeItem('_token');
    } else {
      if (token) {
        localStorage.setItem('_token', token);
      } else {
        token = localStorage.getItem('_token');
      }
    }
    var openId = Url.getQuery('_openId') || Url.getHashQuery('_openId');
    if (openId) {
      localStorage.setItem('_openId', openId);
    } else {
      openId = localStorage.getItem('_openId');
    }
    var userId = Url.getQuery('_userId') || Url.getHashQuery('_userId');
    if (userId) {
      localStorage.setItem('_userId', userId);
    } else {
      userId = localStorage.getItem('_userId');
    }
    return {
      token: token,
      openId: openId,
      userId: userId
    };
  },
  getLocation: function getLocation() {
    return {
      lat: Url.getQuery('lat') || Url.getHashQuery('lat') || 31.231706,
      lng: Url.getQuery('lng') || Url.getHashQuery('lng') || 121.472644
    };
  },
  getCity: function getCity() {
    return {
      cityId: Url.getQuery('ci') || Url.getHashQuery('ci')
    };
  },
  /**
   * @description 登录方法
   */
  login: function login() {
    try {
      var locationUrl = new URL(window.location.href);
      var redirectURL = locationUrl.toString();
      // 跳转登录页面
      var url = "".concat(passportUrl, "/bankLogin?appName=hwfastapp&redirectURL=").concat(encodeURIComponent(redirectURL));
      // 必须为maoyan.com下的子域名，否则cookie种不上，导致循环跳转
      if (location.hostname.indexOf('maoyan') >= 0) {
        location.href = url;
      } else {
        return Promise.reject(new Error('不支持当前域名'));
      }
    } catch (err) {
      return Promise.reject(new Error('小喵提醒您，请返回入口后再次进入'));
    }
  }
};